import {createContext} from "react";

const BundleContext = createContext(null)

const BundleCategoryContext = createContext(null)

export {BundleContext, BundleCategoryContext}